import script from "./CalendarioSimplesComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarioSimplesComponent.vue?vue&type=script&setup=true&lang=js"

import "./CalendarioSimplesComponent.vue?vue&type=style&index=0&id=041089d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-041089d2"]])

export default __exports__